import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "ThanksPage",
  class: /*#__PURE__*/_normalizeClass(`with_white_bg `)
}
const _hoisted_2 = { class: "fs24 fw600" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = { class: "mt20" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = { class: "w100 centered" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.getTitle()), 1),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: "fs14 kaigyo",
          textContent: _toDisplayString(_ctx.getContent())
        }, null, 8, _hoisted_5)
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      (_ctx.hasButton())
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "mt40 circle_button skyblueBg rad8 fs18",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goLink && _ctx.goLink(...args)))
          }, _toDisplayString(this.room.room_setting.thanks_page.button_name), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}